import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react";

export const ProgressBar: FC<{
  value: number;
  secondaryValue?: number;
}> = observer(({ value, secondaryValue = 0 }) => {
  const [animate, setAnimate] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);
    }, 4000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const width = value === 1 ? 100 : value < 1 ? value * 100 : value;
  const secondaryWidth =
    secondaryValue === 1 ? 100 : secondaryValue < 1 ? secondaryValue * 100 : secondaryValue;

  return (
    <div
      className={
        "tw-relative tw-border border-gray bg-default tw-rounded-xl tw-h-3 tw-w-full" +
        (animate ? " tw-animate-pulse" : "")
      }
    >
      <div
        className={"tw-absolute bg-primary-light"}
        style={{ width: `${secondaryWidth}%`, height: "100%" }}
      ></div>
      <div
        className={"tw-absolute bg-gray-x-hard tw-rounded-xl"}
        style={{ width: `${width}%`, height: "100%" }}
      ></div>
    </div>
  );
});
